import { FrameworkSearchPage } from '@features/Framework/Search/FrameworkSearchPage'
import { frameworkSearchSchema } from '@services/queryOptions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/framework/search')({
  validateSearch: frameworkSearchSchema,
  loaderDeps: ({ search }) => search,
  component: FrameworkSearchPage,
  staticData: { breadcrumb: 'Framework' },
})
